import Vue from 'vue'
import VueI18n from 'vue-i18n'
import th from '@/locales/th.json'
Vue.use(VueI18n)

export default new VueI18n({
  locale: 'th',
  fallbackLocale: 'th',
  localeDir: 'locales',
  messages: { th },
})
